export interface RedirectResponseModel {
    code: number;
    url: string;
}
